import React from 'react'
import { Button, Content, Flex, List, Text } from '@leverege/ui-elements'

import S from './ClientIdScreen.css'
import ClientIdItem from './ClientIdItem'
import useClientIds from './useClientIds'
import EditModel from './EditModel'
import ClientIdEditor from './ClientIdEditor'
import AddDialog from './AddDialog'
import ClientIdModel from './ClientIdModel'

export default function ClientIdScreen( props ) {
  const {
    clientIds,
    clientIdsApi,
    onAddClient,
    onClose,
    onCreateClientId,
    onDelete,
    onSave,
    selectedItem,
    selector,
    showAdd,
  } = useClientIds( props )

  return (
    <Content>

      <Content.Header className={S.header}>
        <Flex className={S.headerRow} direction="row" justify="space-between">
          <Text variant="screenTitle">Client IDs</Text>
          <Button onClick={onCreateClientId}> 
            <i className="fa fa-fw fa-circle-plus fa-lg" />
            {' '}
            New Client ID
          </Button>
        </Flex>
      </Content.Header>
      <Content.Area>
        <Content vFill horizontal>
          <Content.Area>
            <List selector={selector}>
              <List.Dynamic
                items={clientIds}
                component={ClientIdItem}
                // onEvent={onEvent}
                itemProps={{
                  clientIdsApi
                }} />
            </List>
          </Content.Area>
          <Content.Footer className={S.editor}>
            <AddDialog
              title="Create Client ID"
              editor={ClientIdEditor}
              creator={ClientIdModel}
              onClose={onClose}
              onCreate={onAddClient}
              show={showAdd} />
            <EditModel
              editor={ClientIdEditor}
              title={selectedItem?.clientId || 'Client ID'}
              saveOnChange={false}
              deleteTitle={`Delete ${selectedItem?.clientId || 'This Client ID'}?`}
              deleteMessage="This will permanently remove this Client ID from your project."
              value={selectedItem}
              onDelete={onDelete}
              onSave={onSave} />
          </Content.Footer>
        </Content>
      </Content.Area>
    </Content>
  )
}
